import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector, shallowEqual } from 'react-redux'
import { BoxLabel as BoxHeader } from '../Styled'
import { BoxListContent, BoxCard } from '../Details/Styled'

import { checkEmpty } from './events'

export const BoxLabel = ({ labelTop, labelBottom }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="body1" color="text.secondary" sx={{ width: 280 }}>
        {labelTop}
      </Typography>
      <Typography variant="body1" sx={{ wordBreak: 'break-all' }}>
        {labelBottom}
      </Typography>
    </Box>
  )
}

const Index = ({ data }) => {
  const { details } = useSelector((state) => state.myProfile, shallowEqual)
  const unitNumber = `${data?.unitNumber} | ${data?.unitName}`

  return (
    <BoxCard>
      <Box
        sx={{ display: 'flex', flexDirection: 'column', p: 3, width: '100%' }}
      >
        <BoxHeader>
          <Typography variant="h6" color="primary.main" sx={{ mb: 1 }}>
            ข้อมูลการทำงาน
          </Typography>
        </BoxHeader>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <BoxListContent>
            <BoxLabel labelTop="Unit Number" labelBottom={unitNumber} />
            <BoxLabel
              labelTop="Temp Code"
              labelBottom={checkEmpty(details, 'agentCode')}
            />
          </BoxListContent>
        </Box>
      </Box>
    </BoxCard>
  )
}
export default Index
